export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11529.d1463870.jpg";